import { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import api from '../../../services/api';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Loading from '../../../load/loading';
import HeaderSession from '../../../utils/headerSession';
import { Paper, Typography } from '@mui/material';
import RegisterAccess from '../../../utils/registerAccess';
import ListaVazia from '../../../utils/listaVazia';
import Date from '../../../utils/date';
import Paginacao from '../../../utils/paginacao';
import TabelaLoading from '../../../load/tabelaLoading';
import { useSelector } from 'react-redux';


const styles = {
  hover: { '&:hover': { backgroundColor: '#85287d8a' }, cursor: 'pointer' },
}

const ListaSolicitacoesAnalise = ({ thisStatus }) => {
  const user = useSelector((state) => state.account.user);
  const classes = styles;
  const { id, status } = useParams()
  const [solicitacoes, setSolicitacoes] = useState('');
  // const [status, setStatus] = useState(thisStatus);
  const navigate = useNavigate();
  const [configLista, setConfigLista] = useState('')
  const [perPage, setPerPage] = useState(50)
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));


  useEffect(() => {
    setSolicitacoes('');
    if (status === 'Análise da Amostra') {
      // api.get(`/solicitacao-anlises?status=${status}&perPage=${perPage}&page=${page}`)
      api.get(`/avalicao-analiticas?revisorId=${user?._id}`)
        .then(response => {
          console.log(response)
          setSolicitacoes(response.data.avaliacaoAnaliticas)
          setConfigLista(response.data)
        }).catch(err => {
          // console.log(err)
        })
    } else {
      api.get(`/solicitacao-anlises?status=${status}&perPage=${perPage}&page=${page}`)
        .then(response => {
          // console.log(response)
          setSolicitacoes(response.data.solicitacaoAnalises)
          setConfigLista(response.data)
        }).catch(err => {
          // console.log(err)
        })
    }

  }, [status, id, status, perPage, page])


  return (

    <>
      <RegisterAccess page={'lista de solicitações de analise'} />
      {/* SOLICITAÇÕES DE FARMACOVIGILÂNCIA */}
      {!id &&
        <HeaderSession title={'SOLICITAÇÕES DE ANÁLISE LABORATORIAL DE AMOSTRAS DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE'} />
      }
      <br />

      {solicitacoes ? solicitacoes.length > 0 ?

        <TableContainer sx={{ border: "1px black" }} component={Paper}>

          {status === 'Análise da Amostra' ?
            <Table sx={{ border: "1px", borderColor: "black" }}>
              <TableHead sx={{ backgroundColor: "#dcdede" }}>
                <TableRow>
                  <TableCell align="center" ><Typography noWrap> <strong> Analista </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Revisor </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Produto </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Solicitante </strong></Typography></TableCell>
                  {/* <TableCell align="center" ><Typography noWrap> <strong> Nº de registo</strong></Typography></TableCell> */}
                  {/* <TableCell align="center" ><Typography noWrap> <strong> Grau de urgência </strong></Typography></TableCell> */}
                  {/* <TableCell align="center" ><Typography noWrap> <strong> Estado </strong></Typography></TableCell> */}
                  <TableCell align="center" ><Typography noWrap> <strong> Data da entrada para analise</strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Data da entrada da Solicitação</strong></Typography></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {solicitacoes.map((solicitacao) => (
                  <TableRow key={solicitacao._id} style={classes.hover} onClick={() => { navigate(`/admin/dcqmts/gest/solicitacao-de-analise/${solicitacao?.producto?._id}/${solicitacao?.solicitacaoAnalise?._id}`) }}>
                    <TableCell ><Typography noWrap> {solicitacao?.analista?.dadosPessoais?.nome}</Typography></TableCell>
                    <TableCell  ><Typography noWrap> {solicitacao?.revisor?.dadosPessoais?.nome}</Typography></TableCell>
                    <TableCell  ><Typography noWrap> {solicitacao?.producto?.nome}</Typography></TableCell>
                    <TableCell  ><Typography > {solicitacao?.solicitacaoAnalise.nome}</Typography></TableCell>
                    {/* <TableCell  ><Typography > {solicitacao?.numero}</Typography></TableCell> */}
                    {/* <TableCell ><Typography noWrap> {solicitacao?.grauUrgencia ?? 'Urgente'}</Typography></TableCell> */}
                    {/* <TableCell align="center" ><Typography noWrap> {solicitacao?.status}</Typography></TableCell> */}
                    <TableCell align="center" ><Typography noWrap> <Date date={solicitacao?.solicitacaoAnalise.createdAt} /> </Typography></TableCell>
                    <TableCell align="center" ><Typography noWrap> <Date date={solicitacao?.createdAt} /> </Typography></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            :
            <Table sx={{ border: "1px", borderColor: "black" }}>
              <TableHead sx={{ backgroundColor: "#dcdede" }}>
                <TableRow>
                  <TableCell align="center" ><Typography noWrap> <strong> Solicitado por </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Tipo de remetente </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Entidade </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Quantidade de produtos </strong></Typography></TableCell>
                  {/* <TableCell align="center" ><Typography noWrap> <strong> Forma farmacêutica </strong></Typography></TableCell> */}
                  <TableCell align="center" ><Typography noWrap> <strong> Nº de registo</strong></Typography></TableCell>
                  {/* <TableCell align="center" ><Typography noWrap> <strong> Condições de armazenamento de amostra á chegada do LNCQ </strong></Typography></TableCell> */}
                  {/* <TableCell align="center" ><Typography noWrap> <strong> Grau de urgência </strong></Typography></TableCell> */}
                  <TableCell align="center" ><Typography noWrap> <strong> Estado </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Data da entrada </strong></Typography></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {solicitacoes.map((solicitacao) => (
                  <TableRow key={solicitacao._id} style={classes.hover} onClick={() => { navigate(`/admin/dcqmts/gest/solicitacao-de-analise/${solicitacao._id}`) }}>
                    <TableCell ><Typography noWrap> {solicitacao?.remetidoPor?.nome}</Typography></TableCell>
                    <TableCell  ><Typography noWrap> {solicitacao?.tipoRemetente}</Typography></TableCell>
                    <TableCell  ><Typography noWrap> {solicitacao?.nome}</Typography></TableCell>
                    <TableCell  ><Typography > {solicitacao?.productos?.length}</Typography></TableCell>
                    <TableCell  ><Typography > {solicitacao?.numero}</Typography></TableCell>
                    {/* <TableCell ><Typography noWrap> {solicitacao?.grauUrgencia ?? 'Urgente'}</Typography></TableCell> */}
                    <TableCell align="center" ><Typography noWrap> {solicitacao?.status}</Typography></TableCell>
                    <TableCell align="center" ><Typography noWrap> <Date date={solicitacao?.createdAt} /> </Typography></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          }

          <Paginacao
            configLista={configLista}
            lista={solicitacoes}
            page={page}
            setPage={setPage}
            setPerPage={setPerPage}
          // setOrder={setOrder}
          />
        </TableContainer>
        :
        <ListaVazia />
        :
        <TabelaLoading text={'A carregar solicitações'} />
      }
    </>
  )
}

export default ListaSolicitacoesAnalise 
